import React, { useEffect } from "react"

import {includeProviders, mainSite, mainSiteProvider, offices, reports, searchID, userData} from "@signals"
import AnalyzerCommonFilters from "Pages/AnalyzersV2/Filters"
import { useAnalyzerDorFilters } from "Pages/AnalyzersV2/Dor/@hooks"
import { dorSchema } from "./schema"


export default function DorFilters() {
	const { onSubmit, isValid, errors } = useAnalyzerDorFilters()

	useEffect(() => {
		mainSiteProvider.value = false
		includeProviders.value = userData.value?.WebProviderAnalyzerGroupDefault
		mainSite.value = ''
	}, [reports.value, offices.value])

	return <AnalyzerCommonFilters
		components={{
			singleDate: false,
			lengthRental: searchID.value || !!offices.value && !!reports.value,
			mainSite: searchID.value || !mainSiteProvider.value && !!offices.value && !!reports.value,
			mainProvider: searchID.value || !!mainSiteProvider.value && !!offices.value && !!reports.value
		}}
		compProps={{
			lengthRental: { grid: { xs: 1 }, autoSelect: true },
			dates: { grid: { xs: 3 }, multiple: true, autoSelect: false, disableClearable: false },
		}}
		errors={errors}
		onSubmit={onSubmit}
		isValid={isValid}
		schema={dorSchema}
	/>
}